<template>
    <v-bottom-navigation v-model="nav" app grow color="primary">
        <v-btn small value="HomeCard" to="/home-card" exact>
            <span>Data</span>
            <v-icon>$vuetify.icons.pages_home_card</v-icon>
        </v-btn>

        <v-btn small value="Rewards" to="/rewards" exact>
            <span>Wallet</span>
            <v-icon>$vuetify.icons.wallet</v-icon>
        </v-btn>

        <!-- <v-btn small value="Vehicles" to="/vehicles" exact>
            <span>Vehicles</span>
            <v-icon>$vuetify.icons.pages_vehicles</v-icon>
        </v-btn> -->

        <v-btn small value="Marketplace" to="/marketplace" exact>
            <span>Marketplace</span>
            <v-icon>$vuetify.icons.pages_market_place</v-icon>
        </v-btn>
        <!-- <v-btn small value="Timeline" to="/timeline" exact>
            <span>Timeline</span>
            <v-icon>$vuetify.icons.pages_timeline</v-icon>
        </v-btn> -->
    </v-bottom-navigation>
</template>

<script>
    export default {
        name: "NavbarBottom",

        data() {
            return {
                nav: this.currentRoute
            }
        },

        computed: {
             currentRoute() {
                return this.$route && this.$route.name;
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>